import PropTypes from 'prop-types'
import React, { Component } from 'react'

import DateFormatter from '../../shared/components/DateFormatter'

const typeMap = {
  changed: 'Geändert',
  rejected: 'Abgelehnt',
  released: 'Freigegeben',
}

export default
class Message extends Component {

  static propTypes = {
    message: PropTypes.object
  }

  renderSender() {

    const {
      message: {
        isMe, sender, senderId
      }
    } = this.props

    if (!sender) {
      return (
        <strong>
          Unbekannter oder gelöschter Nutzer [ID:
          {senderId}
          ]
        </strong>
      )
    }

    return isMe
      ? (
        <strong>
          {sender.firstname}
          {' '}
          {sender.surname}
        </strong>
      )
      : (
        <a
          onClick={this.handleCreateMessage}
          href={`mailto:${sender.email}`}
        >
          {sender.firstname}
          {' '}
          {sender.surname}
        </a>
      )

  }

  renderDate() {
    const {
      message: {
        sendDate
      }
    } = this.props

    return <DateFormatter date={sendDate} />
  }

  render() {

    const {
      message: {
        type, message
      }
    } = this.props

    return (
      <div
        className="message-entry"
      >
        <div
          className="recipient"
        >
          <div className="clearfix">
            {typeMap[type]}
            {' '}
            von
            {' '}
            {this.renderSender()}
            {message ? ':' : ''}
            <div>
              <small>{this.renderDate()}</small>
            </div>
          </div>
        </div>
        {message
          ? (
            <div
              className="message"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: message
              }}
            />
          )
          : null}
      </div>
    )

  }
}
// <div
//   className="subject"
//   dangerouslySetInnerHTML={{
//     __html: subject
//   }}
// />



// WEBPACK FOOTER //
// ./src/message/components/HistoryListEntry.js